import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { rangeLabel, shiftAnchor } from "@/lib/periods";

const MODES = [
  { id: "WEEK", label: "Weekly" },
  { id: "MONTH", label: "Monthly" },
  { id: "QUARTER", label: "Quarterly" },
  { id: "YEAR", label: "Yearly" },
  { id: "CUSTOM", label: "Custom" },
];

export function PeriodBar({ mode, setMode, anchor, setAnchor, custom, setCustom, range, idPrefix = "period" }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-3 flex-wrap">
      <div className="flex gap-1 flex-wrap">
        {MODES.map((m) => (
          <Button
            key={m.id}
            size="sm"
            variant={mode === m.id ? "default" : "outline"}
            className={mode === m.id ? "bg-[#1A2744] text-white" : ""}
            onClick={() => setMode(m.id)}
            data-testid={`${idPrefix}-mode-${m.id.toLowerCase()}`}
          >
            {m.label}
          </Button>
        ))}
      </div>
      {mode !== "CUSTOM" ? (
        <div className="flex items-center gap-1">
          <Button size="icon" variant="outline" className="h-8 w-8" onClick={() => setAnchor(shiftAnchor(mode, anchor, -1))} data-testid={`${idPrefix}-prev`}>
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <span className="text-sm font-medium text-[#1A2744] min-w-[170px] text-center" data-testid={`${idPrefix}-label`}>
            {rangeLabel(mode, range, anchor)}
          </span>
          <Button size="icon" variant="outline" className="h-8 w-8" onClick={() => setAnchor(shiftAnchor(mode, anchor, 1))} data-testid={`${idPrefix}-next`}>
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <Input type="date" className="h-8 w-[150px]" value={custom.start} onChange={(e) => setCustom({ ...custom, start: e.target.value })} data-testid={`${idPrefix}-custom-start`} />
          <span className="text-gray-400 text-sm">to</span>
          <Input type="date" className="h-8 w-[150px]" value={custom.end} onChange={(e) => setCustom({ ...custom, end: e.target.value })} data-testid={`${idPrefix}-custom-end`} />
        </div>
      )}
    </div>
  );
}
